import { Theme, withTheme } from "@material-ui/core"
import { first, last } from "lodash"
import { Router as RouterProps, withRouter } from "next/router"
import React from "react"
import { compose } from "react-apollo"
import { Maybe, MerchantInfoQueryComponent, MerchantInfoQueryIcons } from "../../../../graphql/generated-types"
import { getLocationInfo, getLocationSettings } from "../../../../utils/data"
import MetadataComponent from "./MetadataComponent"
import { getActiveAppSection } from "../../../../utils/router"

interface Props {
    theme: Theme
    router: RouterProps
}

export interface MetadataIcons {
    fallbackIcon?: MerchantInfoQueryIcons
    appleTouchIcon?: MerchantInfoQueryIcons
    favIcon32?: MerchantInfoQueryIcons
    favIcon16?: MerchantInfoQueryIcons
    msTileImage?: MerchantInfoQueryIcons
}

class MetadataComponentWrapper extends React.PureComponent<Props> {
    getMetadataIcons = (icons: Maybe<MerchantInfoQueryIcons[]>): MetadataIcons => {
        if (!icons || !icons.length) {
            return {}
        }

        const firstIcon = first(icons)
        const lastIcon = last(icons)

        const appleTouchIcon = icons && (icons.find((i) => i.sizes === "180x180") || lastIcon)
        const favIcon32 = icons && icons.find((i) => i.sizes === "32x32")
        const favIcon16 = icons && icons.find((i) => i.sizes === "16x16")
        const msTileImage = icons && icons.find((i) => i.sizes === "150x150")

        return {
            fallbackIcon: firstIcon,
            appleTouchIcon: appleTouchIcon,
            favIcon32: favIcon32,
            favIcon16: favIcon16,
            msTileImage: msTileImage,
        }
    }

    generateJsonManifest = (
        accountName: Maybe<string>,
        locationName: Maybe<string>,
        jsonFormatIcons: Maybe<MerchantInfoQueryIcons[]>
    ) => ({
        name: accountName ? `${accountName}${accountName ? ` - ${accountName}` : ""}` : "MakeItButter.com",
        short_name: locationName ? locationName : accountName ? accountName : "MakeItButter",
        description: "Bespoke online ordering for your restaurant",
        background_color: "#000000",
        // theme_color: "#FFFFFF",
        display: "standalone",
        icons:
            jsonFormatIcons && jsonFormatIcons.length > 0
                ? jsonFormatIcons
                : [
                      {
                          src: "/assets/icons/android-chrome-192x192.png",
                          sizes: "192x192",
                          type: "image/png",
                      },
                      {
                          src: "/assets/icons/android-chrome-512x512.png",
                          sizes: "512x512",
                          type: "image/png",
                      },
                  ],
    })

    render() {
        if (!getActiveAppSection(this.props.router)) {
            return null
        }
        return (
            <MerchantInfoQueryComponent fetchPolicy="cache-and-network">
                {({ error, data }) => {
                    if (error || !data || !data.merchantInfo) {
                        return null
                    }

                    const merchantInfo = data.merchantInfo
                    const locationInfo = getLocationInfo(merchantInfo)
                    const locationSettings = locationInfo && getLocationSettings(locationInfo)

                    const icons: Maybe<MerchantInfoQueryIcons[]> = locationSettings && locationSettings.icons
                    const metadataIcons = this.getMetadataIcons(icons)

                    const themeColor: string = this.props.theme.palette.primary.main

                    const accountName = merchantInfo && merchantInfo.name
                    const locationName = locationInfo && locationInfo.name
                    const jsonManifest = this.generateJsonManifest(accountName, locationName, icons)

                    return (
                        <MetadataComponent
                            accountName={accountName}
                            locationName={locationName}
                            metadataIcons={metadataIcons}
                            jsonManifest={jsonManifest}
                            themeColor={themeColor}
                        />
                    )
                }}
            </MerchantInfoQueryComponent>
        )
    }
}

const composed = compose(withTheme, withRouter)

export default composed(MetadataComponentWrapper)
